import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Visit, VisitResult } from '../../models/visit';

@Component({
    selector: 'app-visit-detail-dialog',
    templateUrl: './visit-detail-dialog.component.html',
    styleUrls: ['./visit-detail-dialog.component.css']
})
export class VisitDetailDialogComponent implements OnInit {

    visit: Visit;
    isReporting: boolean = false;

    results: VisitResult[] = ['tres_interesse', 'interesse', 'peu_interesse', 'pas_interesse', 'a_revoir', 'offre_faite'];

    constructor(
        public dialogRef: MatDialogRef<VisitDetailDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.visit = { ...data.visit };
    }

    ngOnInit(): void {
    }

    close(): void {
        this.dialogRef.close();
    }

    edit(): void {
        this.dialogRef.close({ action: 'edit', visit: this.visit });
    }

    cancelVisit(): void {
        if (confirm('Voulez-vous vraiment annuler cette visite ?')) {
            this.visit.status = 'annulee';
            this.dialogRef.close({ action: 'update', visit: this.visit });
        }
    }

    toggleReport(): void {
        this.isReporting = !this.isReporting;
    }

    saveReport(): void {
        this.visit.status = 'terminee';
        this.dialogRef.close({ action: 'update', visit: this.visit });
    }
}
